import React, {Fragment, useContext, useEffect, useState} from "react";
import {RootStoreContext} from "../../core/store/rootStore";
import {observer} from "mobx-react";
import {Button, Col, Form, FormGroup, Input, Label, Row, Table} from "reactstrap";
import LoadingOverlay from "react-loading-overlay";
import ReactJson from "react-json-view";
import { format, parseISO } from 'date-fns'
import CrifRequestType from "../../shared/enums/crifRequestType";
import CrifReportType from "../../shared/enums/crifReportType";
import DatePicker from "react-datepicker";
import Locale from "date-fns/locale/fr-CH/index.js";
import CrifReportTypeSelect from "../../shared/helpers/crifReportTypeSelect";
import CrifRequestTypeSelect from "../../shared/helpers/crifRequestTypeSelect";
import UserSelect from "../../shared/helpers/userSelect";
import "./logs.css";
import ReactPaginate from "react-paginate";
import {DebounceInput} from "react-debounce-input";

const LogsList = () => {
    const rootStore = useContext(RootStoreContext);

    const { getLogs, logsList, newLogCriteria } = rootStore.crifStore;

    let [logCriteria, setLogCriteria] = useState(newLogCriteria());

    useEffect(() => {
        getLogWithCriteria();
    }, [logCriteria]);

    let [loading, setLoading] = useState(false);

    function formatDate(dateAsString) {
        return format(parseISO(dateAsString), 'dd/MM/yyyy HH:mm:ss');
    }

    function getNameForCrifRequestType(crifRequestType) {
        return CrifRequestType[crifRequestType];
    }

    function getNameForReportType(reportType) {
        return CrifReportType[reportType];
    }

    function searchLogs(event) {
        event.preventDefault();

        getLogWithCriteria();
    }

    function getLogWithCriteria() {
        setLoading(true);
        getLogs(logCriteria).then(() => {
            setLoading(false);
        });
    }

    const inputChange = (e) => {
        const { name, value } = e.target;
        let realValue = value;

        if (JSON.parse(e.target.getAttribute("data-number")))
            realValue = Number(realValue);

        if (e.target.checked)
            realValue = !!e.target.checked;

        setLogCriteria((lastUpdate) => ({
            ...lastUpdate,
            [name]: realValue,
            page: 1
        }));
    };

    const debounceFieldChange = (val) => {
        setLogCriteria((lastUpdate) => ({
            ...lastUpdate,
            filter: val.value,
            page: 1
        }));
    };

    function setDateValue(value, formattedValue, field) {
        let isoDateTime = new Date(value.getTime() - (value.getTimezoneOffset() * 60000)).toISOString();

        setLogCriteria((lastUpdate) => ({
            ...lastUpdate,
            [field]: value,
            [field + "ISO"]: isoDateTime,
            page: 1
        }));
    }

    function convertUTCDateToLocalDate(date) {
        let newDate = new Date(date);
        newDate.setMinutes(date.getMinutes() - date.getTimezoneOffset());
        return newDate;
    }

    function changePage(pageSettings) {
        setLogCriteria((lastUpdate) => ({
            ...lastUpdate,
            page: pageSettings.selected + 1,
        }));
    }

    function RenderPager() {
        if (logsList && logsList.results && logsList.results.length > 0) {
            return <div className="d-flex">
                <div>
                    <ReactPaginate
                        breakLabel="..."
                        nextLabel=">"
                        onPageChange={changePage}
                        pageRangeDisplayed={5}
                        pageCount={logsList.pageCount}
                        forcePage={logsList.currentPage - 1}
                        previousLabel="<"
                        className="pagination"
                        renderOnZeroPageCount={null}
                    />
                </div>
                <div className="ml-auto">
                    Total: {logsList.rowCount}
                </div>
            </div>
        }

        return null;
    }

    function getResponseBasedOnType(log) {
        if (log.result === 1) {
            return log.error;
        }
        else {
            return <ReactJson src={JSON.parse(log.response)} displayDataTypes={false} displayObjectSize={false} indentWidth={2} collapsed={true} />
        }
    }

    return (
        <Fragment>
            <div><b>Liste des journaux</b></div>
            <div className="mt-3">
                <Form onSubmit={searchLogs}>
                    <Row>
                        <Col md={4}>
                            <FormGroup row>
                                <Label for="user" sm={4}>Filtre</Label>
                                <Col sm={8}>
                                    <DebounceInput
                                        minLength={2}
                                        debounceTimeout={300}
                                        name="filter"
                                        id="filter"
                                        className="form-control"
                                        onChange={event => debounceFieldChange({value: event.target.value})} />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="user" sm={4}>Utilisateur</Label>
                                <Col sm={8}>
                                    <UserSelect onChange={inputChange.bind(this)} name="userId"></UserSelect>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="crifReportType" sm={4}>Résultats des tests</Label>
                                <Col sm={8}>
                                    <FormGroup check inline>
                                        <Input type="checkbox"
                                               id="isTest"
                                               name="isTest"
                                               onChange={inputChange.bind(this)} />
                                    </FormGroup>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup row>
                                <Label for="startDate" sm={4}>Du</Label>
                                <Col sm={8}>
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy HH:mm"
                                        selected={logCriteria.startDate}
                                        onChange={(date) => setDateValue(date, null, "startDate")}
                                        className="form-control"
                                        showTimeSelect
                                        timeCaption="Heure"
                                        locale={Locale} />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="crifRequestType" sm={4}>Type de demande CRIF</Label>
                                <Col sm={8}>
                                    <CrifRequestTypeSelect onChange={inputChange.bind(this)} name="crifRequestType"></CrifRequestTypeSelect>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup row>
                                <Label for="endDate" sm={4}>Au</Label>
                                <Col sm={8}>
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy HH:mm"
                                        selected={logCriteria.endDate}
                                        onChange={(date) => setDateValue(date, null, "endDate")}
                                        className="form-control"
                                        showTimeSelect
                                        timeCaption="Heure"
                                        locale={Locale} />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="crifReportType" sm={4}>Type de rapport CRIF</Label>
                                <Col sm={8}>
                                    <CrifReportTypeSelect onChange={inputChange.bind(this)} name="crifReportType"></CrifReportTypeSelect>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div className="mt-3">
                <div className="table-scroll">
                    <LoadingOverlay
                        active={loading}
                        spinner>
                        <Table striped size="sm">
                            <thead>
                            <tr key={1}>
                                <th style={{width: "150px"}}>Date</th>
                                <th style={{width: "130px"}}>Utilisateur</th>
                                <th style={{width: "180px"}}>Type de rapport</th>
                                <th style={{width: "100px"}}>Type de requête</th>
                                <th style={{width: "400px"}}>Requête</th>
                                <th style={{width: "400px"}}>Réponse</th>
                            </tr>
                            </thead>
                            <tbody>
                            {logsList && logsList.results && logsList.results.length > 0 && logsList.results.map((log, index) => (
                                <tr key={index}>
                                    <td>{formatDate(log.date)}</td>
                                    <td>{log.createdBy}</td>
                                    <td>{getNameForReportType(log.reportType)}</td>
                                    <td>{getNameForCrifRequestType(log.crifRequestType)}</td>
                                    <td><ReactJson src={JSON.parse(log.request)} displayDataTypes={false} displayObjectSize={false} indentWidth={2} collapsed={true} /></td>
                                    <td>{getResponseBasedOnType(log)}</td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </LoadingOverlay>
                </div>
                <RenderPager></RenderPager>
            </div>
        </Fragment>
    )
};

export default observer(LogsList);